/* Quemsa: interacciones del tema (sin dependencias) */
(function () {
  "use strict";

  var Q = window.Quemsa || { routes: {} };
  var R = Q.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, "text/html"); }
  function lock(on) { document.body.classList.toggle("lock", on); }

  /* ---------- Aviso flotante ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $("#Toast"); if (!el) return;
    el.textContent = msg; el.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("on"); }, 2200);
  }

  /* ---------- Menu en celular ---------- */
  function initMenu() {
    var burger = $("[data-burger]"), menu = $("#Menu");
    if (!burger || !menu || burger.dataset.ready) return;
    burger.dataset.ready = "1";
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      burger.setAttribute("aria-expanded", open);
    });
  }

  /* ---------- Burbujas ---------- */
  function initBubbles(root) {
    if (Q.bubbles === false) return;
    $$("[data-bubbles]", root).forEach(function (b) {
      if (b.childElementCount) return;
      var n = +b.dataset.bubbles || 20;
      for (var k = 0; k < n; k++) {
        var s = document.createElement("span"), size = 14 + Math.random() * 60;
        s.className = "keep";
        s.style.width = s.style.height = size + "px";
        s.style.left = Math.random() * 100 + "%";
        s.style.animationDuration = (10 + Math.random() * 14) + "s";
        s.style.animationDelay = (-Math.random() * 20) + "s";
        b.appendChild(s);
      }
    });
  }

  /* ---------- Aparecer al bajar y contadores ---------- */
  function countUp(el) {
    var end = +el.dataset.count, suf = el.dataset.suffix || "", t0 = null;
    if (reduceMotion || !end) { el.textContent = end + suf; return; }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / 1400, 1);
      el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = "0" + suf;
    requestAnimationFrame(step);
  }
  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add("in");
      $$("[data-count]", e.target).forEach(countUp);
      io.unobserve(e.target);
    });
  }, { threshold: 0.15 }) : null;
  function initReveal(root) {
    $$(".reveal:not(.in)", root).forEach(function (el) {
      if (io && !document.body.classList.contains("no-reveal")) io.observe(el);
      else el.classList.add("in");
    });
  }

  /* ---------- Carrusel principal ---------- */
  function initSlideshow(root) {
    $$("[data-slideshow]", root).forEach(function (hero) {
      if (hero.dataset.ready) return;
      hero.dataset.ready = "1";
      var slides = $$(".slide", hero), dots = $("[data-dots]", hero), i = 0, timer;
      var ms = +hero.dataset.interval || 6000;
      if (slides.length < 2) return;
      slides.forEach(function (_, n) {
        var d = document.createElement("button");
        d.type = "button"; d.className = "dot" + (n === 0 ? " on" : "");
        d.setAttribute("aria-label", "Ir a la diapositiva " + (n + 1));
        d.addEventListener("click", function () { go(n); restart(); });
        dots.appendChild(d);
      });
      function go(n) {
        slides[i].classList.remove("active"); dots.children[i].classList.remove("on");
        i = (n + slides.length) % slides.length;
        slides[i].classList.add("active"); dots.children[i].classList.add("on");
      }
      function restart() { clearInterval(timer); if (!reduceMotion) timer = setInterval(function () { go(i + 1); }, ms); }
      $("[data-next]", hero).addEventListener("click", function () { go(i + 1); restart(); });
      $("[data-prev]", hero).addEventListener("click", function () { go(i - 1); restart(); });
      var x0 = null;
      hero.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) { go(i + (dx < 0 ? 1 : -1)); restart(); }
        x0 = null;
      });
      /* En el editor de Shopify: mostrar la diapositiva seleccionada */
      hero.addEventListener("shopify:block:select", function (e) {
        var n = slides.indexOf(e.target); if (n > -1) { go(n); clearInterval(timer); }
      });
      hero.addEventListener("shopify:block:deselect", restart);
      restart();
    });
  }

  /* ---------- Fotos de la sucursal ---------- */
  function initFadeCarousel(root) {
    $$("[data-fade-carousel]", root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = "1";
      var imgs = $$("img", box), dots = $("[data-dots]", box), i = 0, t;
      if (imgs.length < 2) return;
      imgs.forEach(function (_, n) {
        var d = document.createElement("button");
        d.type = "button"; d.className = n === 0 ? "on" : "";
        d.setAttribute("aria-label", "Foto " + (n + 1));
        d.onclick = function () { go(n); start(); };
        dots.appendChild(d);
      });
      function go(n) {
        imgs[i].classList.remove("on"); dots.children[i].classList.remove("on");
        i = (n + imgs.length) % imgs.length;
        imgs[i].classList.add("on"); dots.children[i].classList.add("on");
      }
      function start() { clearInterval(t); if (!reduceMotion) t = setInterval(function () { go(i + 1); }, 4500); }
      start();
    });
  }

  /* ---------- Mi pedido ---------- */
  var drawer = function () { return $("#CartDrawer"); };

  function setCount(n, bump) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      if (bump) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
  }

  function cartPageSection() {
    var page = $("[data-cart-page]");
    var wrap = page && page.closest(".shopify-section");
    return wrap ? wrap.id.replace("shopify-section-", "") : null;
  }

  function renderCart(sections, bump) {
    if (!sections) return;
    var html = sections["cart-drawer"];
    if (html) {
      var fresh = $("[data-cart-inner]", parseHTML(html));
      var current = $("[data-cart-inner]", drawer());
      if (fresh && current) {
        current.replaceWith(fresh);
        setCount(+fresh.dataset.count || 0, bump);
      }
    }
    var pageId = cartPageSection();
    if (pageId && sections[pageId]) {
      var pageFresh = $("[data-cart-page]", parseHTML(sections[pageId]));
      var pageNow = $("[data-cart-page]");
      if (pageFresh && pageNow) pageNow.replaceWith(pageFresh);
    }
  }

  function sectionsToRender() {
    var ids = ["cart-drawer"], pageId = cartPageSection();
    if (pageId) ids.push(pageId);
    return ids.join(",");
  }

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.hidden = false; lock(true);
    var x = $(".x", d); if (x) x.focus();
  }
  function closeDrawer() {
    var d = drawer(); if (!d || d.hidden) return;
    d.hidden = true; lock(false);
  }

  function addToCart(form) {
    var btn = $("[type=submit]", form), err = $("[data-form-error]", form);
    if (err) { err.hidden = true; err.textContent = ""; }
    if (btn) btn.classList.add("is-busy");
    var data = new FormData(form);
    data.append("sections", sectionsToRender());
    data.append("sections_url", window.location.pathname);
    return fetch(R.cartAdd + ".js", { method: "POST", body: data, headers: { Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.body.description || res.body.message || "No pudimos agregar el producto.";
          if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); }
          return;
        }
        renderCart(res.body.sections, true);
        closeQuick();
        toast("Agregado a tu pedido");
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove("is-busy"); });
  }

  function changeLine(line, qty) {
    var list = $("[data-cart-list]", drawer());
    if (list) list.classList.add("is-busy");
    return fetch(R.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionsToRender(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart.sections, false); })
      .catch(function () { window.location.href = R.cart; });
  }

  function clearCart() {
    return fetch((R.cart || "/cart") + "/clear.js", { method: "POST", headers: { Accept: "application/json" } })
      .then(function () { return fetch((R.root || "/") + "?sections=" + sectionsToRender()); })
      .then(function (r) { return r.json(); })
      .then(function (sections) { renderCart(sections, false); });
  }

  /* ---------- Ventana rapida de producto ---------- */
  var quick = function () { return $("#QuickView"); };
  function openQuick(url) {
    var m = quick(), box = $("#QuickViewBox");
    if (!m || !box) { window.location.href = url; return; }
    box.className = "mbox loading";
    box.innerHTML = '<div class="spinner"></div>';
    m.hidden = false; lock(true);
    var base = url.split("#")[0];
    fetch(base + (base.indexOf("?") > -1 ? "&" : "?") + "section_id=quick-view")
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var inner = $("[data-quick-inner]", parseHTML(html));
        if (!inner || !$(".minfo", inner)) throw new Error("vacio");
        box.className = "mbox";
        box.innerHTML = "";
        box.appendChild(inner);
        var title = $(".minfo h2", inner);
        if (title && title.id) box.setAttribute("aria-labelledby", title.id);
        var x = $(".x", inner); if (x) x.focus();
      })
      .catch(function () { window.location.href = url; });
  }
  function closeQuick() {
    var m = quick(); if (!m || m.hidden) return;
    m.hidden = true;
    if (!drawer() || drawer().hidden) lock(false);
  }

  /* ---------- Formulario de producto (ventana y pagina) ---------- */
  function onVariantChange(select) {
    var opt = select.options[select.selectedIndex];
    var root = select.closest(".minfo");
    if (!opt || !root) return;
    var price = $("[data-price]", root);
    if (price && opt.dataset.price) price.innerHTML = opt.dataset.price;
    var btn = $("[data-add-btn]", root), ok = opt.dataset.available === "true";
    if (btn) { btn.disabled = !ok; btn.textContent = ok ? "Agregar a mi pedido" : "Agotado"; }
    if (root.closest("[data-product-root]") && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set("variant", opt.value);
      window.history.replaceState({}, "", u.toString());
    }
  }

  /* ---------- Catalogo: filtros, pestañas y "ver mas" ---------- */
  function catalogFetch(url, catalog) {
    var id = catalog.dataset.sectionId;
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    return fetch(url + sep + "section_id=" + encodeURIComponent(id))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(parseHTML);
  }

  function applyFilters(form) {
    var catalog = form.closest("[data-catalog]");
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== "") params.append(k, v); });
    var url = form.action.split("?")[0] + (params.toString() ? "?" + params.toString() : "");
    var results = $("[data-results]", catalog);
    results.classList.add("is-busy");
    catalogFetch(url, catalog).then(function (doc) {
      ["[data-results]", "[data-tfoot]"].forEach(function (sel) {
        var fresh = $(sel, doc), now = $(sel, catalog);
        if (fresh && now) now.replaceWith(fresh);
      });
      var freshForm = $("[data-filter-form]", doc);
      if (freshForm) form.innerHTML = freshForm.innerHTML;
      var fc = $("[data-fcount]", catalog), fcNew = $("[data-fcount]", doc);
      if (fc && fcNew) { fc.textContent = fcNew.textContent; fc.hidden = fcNew.hidden; }
      if (window.history.replaceState) window.history.replaceState({}, "", url);
    }).catch(function () { window.location.href = url; });
  }

  function loadMore(link) {
    var catalog = link.closest("[data-catalog]");
    if (!catalog) { window.location.href = link.href; return; }
    link.setAttribute("aria-busy", "true");
    catalogFetch(link.href, catalog).then(function (doc) {
      var grid = $("[data-grid]", catalog), fresh = $("[data-grid]", doc);
      if (fresh) Array.prototype.slice.call(fresh.children).forEach(function (c) { grid.appendChild(c); });
      var more = $("[data-more]", catalog), moreNew = $("[data-more]", doc);
      if (more && moreNew) more.innerHTML = moreNew.innerHTML;
    }).catch(function () { window.location.href = link.href; });
  }

  function initCatalog(root) {
    $$("[data-filter-form]", root).forEach(function (form) {
      var fc = $("[data-fcount]", form.closest("[data-catalog]") || document);
      if (fc && !fc.hidden) {
        form.hidden = false;
        var t = $("[data-ftoggle]", form.closest(".tools"));
        if (t) t.setAttribute("aria-expanded", "true");
      }
    });
  }

  /* ---------- Formulario de contacto: enviar tambien por WhatsApp ---------- */
  function initContactForm(root) {
    $$("[data-form-wa]", root).forEach(function (b) { b.hidden = false; });
  }
  function sendFormByWhatsApp(btn) {
    var f = btn.closest("form"), note = $("[data-form-note]", f);
    var get = function (n) { var el = f.elements["contact[" + n + "]"]; return el ? String(el.value || "").trim() : ""; };
    var ok = true;
    ["name", "body"].forEach(function (n) {
      var el = f.elements["contact[" + n + "]"], bad = !get(n);
      if (el) el.classList.toggle("bad", bad);
      if (bad) ok = false;
    });
    if (!ok) {
      if (note) { note.textContent = "Por favor escribe tu nombre y lo que necesitas."; note.classList.add("err"); }
      return;
    }
    if (note) note.classList.remove("err");
    var t = "Hola, quiero una cotización.\nNombre: " + get("name") +
      (get("empresa") ? "\nEmpresa: " + get("empresa") : "") +
      (get("phone") ? "\nTeléfono: " + get("phone") : "") +
      (get("email") ? "\nCorreo: " + get("email") : "") +
      (get("giro") ? "\nGiro: " + get("giro") : "") +
      "\nNecesito: " + get("body");
    window.open(btn.dataset.formWa + "?text=" + encodeURIComponent(t), "_blank", "noopener");
  }

  /* ---------- Eventos globales (delegados) ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var modified = e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1;

    var opener = t.closest("[data-cart-open]");
    if (opener && drawer() && !$("[data-cart-page]")) { e.preventDefault(); openDrawer(); return; }

    if (t.closest("[data-dclose]")) { closeDrawer(); return; }
    if (t.closest("#QuickView [data-close]")) { closeQuick(); return; }

    var line = t.closest("[data-line]");
    if (line) { e.preventDefault(); changeLine(+line.dataset.line, +line.dataset.qty); return; }

    if (t.closest("[data-cart-clear]")) { e.preventDefault(); clearCart(); return; }

    var q = t.closest("[data-quick]");
    if (q && !modified && !t.closest("#QuickView")) { e.preventDefault(); openQuick(q.getAttribute("data-quick")); return; }

    var qtyBtn = t.closest(".qty [data-qty]");
    if (qtyBtn) {
      var input = $("input", qtyBtn.closest(".qty"));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (+qtyBtn.dataset.qty));
      return;
    }

    var thumb = t.closest("[data-thumb]");
    if (thumb) {
      var box = thumb.closest(".mimg"), main = $("[data-main-img] img", box);
      if (main) { main.src = thumb.dataset.thumb; main.removeAttribute("srcset"); }
      $$("[data-thumb]", box).forEach(function (b) { b.setAttribute("aria-current", b === thumb); });
      return;
    }

    var seg = t.closest("[data-seg]");
    if (seg) {
      var tools = seg.closest(".tools");
      $$("[data-seg]", tools).forEach(function (b) { b.setAttribute("aria-selected", b === seg); });
      $$("[data-seg-panel]", tools).forEach(function (p) { p.hidden = p.dataset.segPanel !== seg.dataset.seg; });
      return;
    }

    var ft = t.closest("[data-ftoggle]");
    if (ft) {
      var panel = document.getElementById(ft.getAttribute("aria-controls"));
      if (panel) { panel.hidden = !panel.hidden; ft.setAttribute("aria-expanded", !panel.hidden); }
      return;
    }

    var more = t.closest("[data-load-more]");
    if (more && !modified) { e.preventDefault(); loadMore(more); return; }

    var waForm = t.closest("[data-form-wa]");
    if (waForm) { e.preventDefault(); sendFormByWhatsApp(waForm); return; }

    if (t.closest("#Menu a") && $("#Menu").classList.contains("open")) {
      $("#Menu").classList.remove("open");
      var b = $("[data-burger]"); if (b) b.setAttribute("aria-expanded", "false");
    }
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form.matches("[data-ajax-add]")) { e.preventDefault(); addToCart(form); }
  });

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t.matches("[data-variant-select]")) onVariantChange(t);
    var ff = t.closest("[data-filter-form]");
    if (ff) applyFilters(ff);
    if (t.matches("input, textarea")) t.classList.remove("bad");
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeQuick(); closeDrawer(); }
  });

  /* ---------- Productos relacionados ---------- */
  function initRecommendations(root) {
    $$("[data-recommendations]", root).forEach(function (sec) {
      if (sec.dataset.ready || $(".mps", sec)) return;
      sec.dataset.ready = "1";
      fetch(sec.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = $("[data-recommendations]", parseHTML(html));
          if (fresh && $(".mps", fresh)) sec.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------- Inicio ---------- */
  /* ---------- Artículo: índice a partir de los subtítulos ---------- */
  function slug(s) {
    return s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }
  function initToc(root) {
    $$("[data-toc]", root).forEach(function (toc) {
      if (toc.dataset.ready) return;
      toc.dataset.ready = "1";
      var body = $("[data-article-body]"), share = $(".share", toc);
      if (!body) return;
      var heads = $$(":scope > h2", body);
      if (heads.length < 2) { $("b", toc).hidden = true; }
      var links = heads.map(function (h) {
        if (!h.id) h.id = slug(h.textContent) || "seccion";
        var a = document.createElement("a");
        a.href = "#" + h.id; a.textContent = h.textContent;
        toc.insertBefore(a, share);
        return a;
      });
      if (heads.length < 2) links.forEach(function (a) { a.remove(); });
      function spy() {
        var y = window.scrollY + 140, k = 0;
        heads.forEach(function (h, i) { if (h.offsetTop <= y) k = i; });
        links.forEach(function (l, i) { l.classList.toggle("on", i === k); });
      }
      window.addEventListener("scroll", spy, { passive: true });
      spy();
    });
  }

  function init(root) {
    initToc(root);
    initRecommendations(root);
    initBubbles(root);
    initReveal(root);
    initSlideshow(root);
    initFadeCarousel(root);
    initCatalog(root);
    initContactForm(root);
  }

  function boot() {
    initMenu();
    init(document);
    var wa = $("#WaFloat");
    if (wa && !reduceMotion) {
      setTimeout(function () {
        wa.classList.add("hint");
        setTimeout(function () { wa.classList.remove("hint"); }, 4000);
      }, 3500);
    }
    if (window.location.hash === "#pedido") openDrawer();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  /* Editor de temas de Shopify: reactivar secciones al editarlas */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
